import React from 'react';
import styled from 'styled-components';

const Divider = styled.div`
  margin-top: 8px;
  border: 2px solid palevioletred;
`;

export default function () {
  return <Divider />;
}
